/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AdminEmissionsRecordsStatsListProviderWithSourceParameterInner,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerFromJSON,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerToJSON,
} from '../models/AdminEmissionsRecordsStatsListProviderWithSourceParameterInner';
import {
    type BulkAssignRequest,
    BulkAssignRequestFromJSON,
    BulkAssignRequestToJSON,
} from '../models/BulkAssignRequest';
import {
    type BulkAssignReviewerRequest,
    BulkAssignReviewerRequestFromJSON,
    BulkAssignReviewerRequestToJSON,
} from '../models/BulkAssignReviewerRequest';
import {
    type BulkEventsArchiveResponse,
    BulkEventsArchiveResponseFromJSON,
    BulkEventsArchiveResponseToJSON,
} from '../models/BulkEventsArchiveResponse';
import {
    type BulkEventsAssignReviewerResponse,
    BulkEventsAssignReviewerResponseFromJSON,
    BulkEventsAssignReviewerResponseToJSON,
} from '../models/BulkEventsAssignReviewerResponse';
import {
    type BulkEventsMoveToInProgressResponse,
    BulkEventsMoveToInProgressResponseFromJSON,
    BulkEventsMoveToInProgressResponseToJSON,
} from '../models/BulkEventsMoveToInProgressResponse';
import {
    type BulkEventsResponse,
    BulkEventsResponseFromJSON,
    BulkEventsResponseToJSON,
} from '../models/BulkEventsResponse';
import {
    type EmissionEventFull,
    EmissionEventFullFromJSON,
    EmissionEventFullToJSON,
} from '../models/EmissionEventFull';
import {
    type EmissionEventFullRequest,
    EmissionEventFullRequestFromJSON,
    EmissionEventFullRequestToJSON,
} from '../models/EmissionEventFullRequest';
import {
    type EmissionEventPartialUpdate,
    EmissionEventPartialUpdateFromJSON,
    EmissionEventPartialUpdateToJSON,
} from '../models/EmissionEventPartialUpdate';
import {
    type EmissionEventUpdate,
    EmissionEventUpdateFromJSON,
    EmissionEventUpdateToJSON,
} from '../models/EmissionEventUpdate';
import {
    type EmissionEventUpdateRequest,
    EmissionEventUpdateRequestFromJSON,
    EmissionEventUpdateRequestToJSON,
} from '../models/EmissionEventUpdateRequest';
import {
    type EventFile,
    EventFileFromJSON,
    EventFileToJSON,
} from '../models/EventFile';
import {
    type EventFileCreate,
    EventFileCreateFromJSON,
    EventFileCreateToJSON,
} from '../models/EventFileCreate';
import {
    type EventFileCreateRequest,
    EventFileCreateRequestFromJSON,
    EventFileCreateRequestToJSON,
} from '../models/EventFileCreateRequest';
import {
    type EventFileOperationRequest,
    EventFileOperationRequestFromJSON,
    EventFileOperationRequestToJSON,
} from '../models/EventFileOperationRequest';
import {
    type HistoryEntry,
    HistoryEntryFromJSON,
    HistoryEntryToJSON,
} from '../models/HistoryEntry';
import {
    type PaginatedEmissionEventFullList,
    PaginatedEmissionEventFullListFromJSON,
    PaginatedEmissionEventFullListToJSON,
} from '../models/PaginatedEmissionEventFullList';
import {
    type PatchedEmissionEventPartialUpdateRequest,
    PatchedEmissionEventPartialUpdateRequestFromJSON,
    PatchedEmissionEventPartialUpdateRequestToJSON,
} from '../models/PatchedEmissionEventPartialUpdateRequest';

export interface EmissioneventsBulkArchiveCreateRequest {
    emissionEventFullRequest: EmissionEventFullRequest;
    assignedTo?: Array<number>;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissioneventsBulkArchiveCreateDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    emissionRecordIds?: Array<string>;
    eventStatus?: Array<EmissioneventsBulkArchiveCreateEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissioneventsBulkArchiveCreateEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissioneventsBulkArchiveCreateExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissioneventsBulkAssignCreateRequest {
    bulkAssignRequest: BulkAssignRequest;
    assignedTo?: Array<number>;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissioneventsBulkAssignCreateDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    emissionRecordIds?: Array<string>;
    eventStatus?: Array<EmissioneventsBulkAssignCreateEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissioneventsBulkAssignCreateEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissioneventsBulkAssignCreateExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissioneventsBulkAssignReviewerCreateRequest {
    bulkAssignReviewerRequest: BulkAssignReviewerRequest;
    assignedTo?: Array<number>;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissioneventsBulkAssignReviewerCreateDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    emissionRecordIds?: Array<string>;
    eventStatus?: Array<EmissioneventsBulkAssignReviewerCreateEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissioneventsBulkAssignReviewerCreateEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissioneventsBulkAssignReviewerCreateExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissioneventsBulkMoveToInProgressCreateRequest {
    emissionEventFullRequest: EmissionEventFullRequest;
    assignedTo?: Array<number>;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissioneventsBulkMoveToInProgressCreateDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    emissionRecordIds?: Array<string>;
    eventStatus?: Array<EmissioneventsBulkMoveToInProgressCreateEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissioneventsBulkMoveToInProgressCreateEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissioneventsBulkMoveToInProgressCreateExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissioneventsFilesCreateRequest {
    id: string;
    eventFileCreateRequest: EventFileCreateRequest;
}

export interface EmissioneventsFilesDestroyRequest {
    fileId: string;
    id: string;
}

export interface EmissioneventsFilesListRequest {
    id: string;
    assignedTo?: Array<number>;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissioneventsFilesListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    emissionRecordIds?: Array<string>;
    eventStatus?: Array<EmissioneventsFilesListEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissioneventsFilesListEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissioneventsFilesListExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissioneventsFilesUpdateRequest {
    id: string;
    eventFileOperationRequest: EventFileOperationRequest;
}

export interface EmissioneventsHistoryListRequest {
    id: string;
    assignedTo?: Array<number>;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissioneventsHistoryListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    emissionRecordIds?: Array<string>;
    eventStatus?: Array<EmissioneventsHistoryListEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissioneventsHistoryListEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissioneventsHistoryListExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissioneventsListRequest {
    assignedTo?: Array<number>;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<EmissioneventsListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    emissionRecordIds?: Array<string>;
    eventStatus?: Array<EmissioneventsListEventStatusEnum>;
    eventStatusWithParentStatus?: Array<EmissioneventsListEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<EmissioneventsListExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    page?: number;
    pageSize?: number;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    search?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface EmissioneventsPartialUpdateRequest {
    id: string;
    patchedEmissionEventPartialUpdateRequest?: PatchedEmissionEventPartialUpdateRequest;
}

export interface EmissioneventsRetrieveRequest {
    id: string;
}

export interface EmissioneventsUpdateRequest {
    id: string;
    emissionEventUpdateRequest: EmissionEventUpdateRequest;
}

/**
 * 
 */
export class EmissioneventsApi extends runtime.BaseAPI {

    /**
     * Creates request options for emissioneventsBulkArchiveCreate without sending the request
     */
    async emissioneventsBulkArchiveCreateRequestOpts(requestParameters: EmissioneventsBulkArchiveCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['emissionEventFullRequest'] == null) {
            throw new runtime.RequiredError(
                'emissionEventFullRequest',
                'Required parameter "emissionEventFullRequest" was null or undefined when calling emissioneventsBulkArchiveCreate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emissionRecordIds'] != null) {
            queryParameters['emission_record_ids'] = requestParameters['emissionRecordIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/bulk_archive/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmissionEventFullRequestToJSON(requestParameters['emissionEventFullRequest']),
        };
    }

    /**
     * Bulk archives all events from queryset.
     */
    async emissioneventsBulkArchiveCreateRaw(requestParameters: EmissioneventsBulkArchiveCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkEventsArchiveResponse>> {
        const requestOptions = await this.emissioneventsBulkArchiveCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkEventsArchiveResponseFromJSON(jsonValue));
    }

    /**
     * Bulk archives all events from queryset.
     */
    async emissioneventsBulkArchiveCreate(requestParameters: EmissioneventsBulkArchiveCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkEventsArchiveResponse> {
        const response = await this.emissioneventsBulkArchiveCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissioneventsBulkAssignCreate without sending the request
     */
    async emissioneventsBulkAssignCreateRequestOpts(requestParameters: EmissioneventsBulkAssignCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['bulkAssignRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkAssignRequest',
                'Required parameter "bulkAssignRequest" was null or undefined when calling emissioneventsBulkAssignCreate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emissionRecordIds'] != null) {
            queryParameters['emission_record_ids'] = requestParameters['emissionRecordIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/bulk_assign/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkAssignRequestToJSON(requestParameters['bulkAssignRequest']),
        };
    }

    /**
     * Bulk assigns events to a user.
     */
    async emissioneventsBulkAssignCreateRaw(requestParameters: EmissioneventsBulkAssignCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkEventsResponse>> {
        const requestOptions = await this.emissioneventsBulkAssignCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkEventsResponseFromJSON(jsonValue));
    }

    /**
     * Bulk assigns events to a user.
     */
    async emissioneventsBulkAssignCreate(requestParameters: EmissioneventsBulkAssignCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkEventsResponse> {
        const response = await this.emissioneventsBulkAssignCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissioneventsBulkAssignReviewerCreate without sending the request
     */
    async emissioneventsBulkAssignReviewerCreateRequestOpts(requestParameters: EmissioneventsBulkAssignReviewerCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['bulkAssignReviewerRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkAssignReviewerRequest',
                'Required parameter "bulkAssignReviewerRequest" was null or undefined when calling emissioneventsBulkAssignReviewerCreate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emissionRecordIds'] != null) {
            queryParameters['emission_record_ids'] = requestParameters['emissionRecordIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/bulk_assign_reviewer/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkAssignReviewerRequestToJSON(requestParameters['bulkAssignReviewerRequest']),
        };
    }

    /**
     * Bulk updates reviewer/approver events to a user.
     */
    async emissioneventsBulkAssignReviewerCreateRaw(requestParameters: EmissioneventsBulkAssignReviewerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkEventsAssignReviewerResponse>> {
        const requestOptions = await this.emissioneventsBulkAssignReviewerCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkEventsAssignReviewerResponseFromJSON(jsonValue));
    }

    /**
     * Bulk updates reviewer/approver events to a user.
     */
    async emissioneventsBulkAssignReviewerCreate(requestParameters: EmissioneventsBulkAssignReviewerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkEventsAssignReviewerResponse> {
        const response = await this.emissioneventsBulkAssignReviewerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissioneventsBulkMoveToInProgressCreate without sending the request
     */
    async emissioneventsBulkMoveToInProgressCreateRequestOpts(requestParameters: EmissioneventsBulkMoveToInProgressCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['emissionEventFullRequest'] == null) {
            throw new runtime.RequiredError(
                'emissionEventFullRequest',
                'Required parameter "emissionEventFullRequest" was null or undefined when calling emissioneventsBulkMoveToInProgressCreate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emissionRecordIds'] != null) {
            queryParameters['emission_record_ids'] = requestParameters['emissionRecordIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/bulk_move_to_in_progress/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmissionEventFullRequestToJSON(requestParameters['emissionEventFullRequest']),
        };
    }

    /**
     * Bulk moves events back to in-progress all events from queryset.
     */
    async emissioneventsBulkMoveToInProgressCreateRaw(requestParameters: EmissioneventsBulkMoveToInProgressCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkEventsMoveToInProgressResponse>> {
        const requestOptions = await this.emissioneventsBulkMoveToInProgressCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkEventsMoveToInProgressResponseFromJSON(jsonValue));
    }

    /**
     * Bulk moves events back to in-progress all events from queryset.
     */
    async emissioneventsBulkMoveToInProgressCreate(requestParameters: EmissioneventsBulkMoveToInProgressCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkEventsMoveToInProgressResponse> {
        const response = await this.emissioneventsBulkMoveToInProgressCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissioneventsFilesCreate without sending the request
     */
    async emissioneventsFilesCreateRequestOpts(requestParameters: EmissioneventsFilesCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emissioneventsFilesCreate().'
            );
        }

        if (requestParameters['eventFileCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'eventFileCreateRequest',
                'Required parameter "eventFileCreateRequest" was null or undefined when calling emissioneventsFilesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/{id}/files/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventFileCreateRequestToJSON(requestParameters['eventFileCreateRequest']),
        };
    }

    /**
     * Retrieves file list for this Event Form.
     */
    async emissioneventsFilesCreateRaw(requestParameters: EmissioneventsFilesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventFileCreate>> {
        const requestOptions = await this.emissioneventsFilesCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventFileCreateFromJSON(jsonValue));
    }

    /**
     * Retrieves file list for this Event Form.
     */
    async emissioneventsFilesCreate(requestParameters: EmissioneventsFilesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventFileCreate> {
        const response = await this.emissioneventsFilesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissioneventsFilesDestroy without sending the request
     */
    async emissioneventsFilesDestroyRequestOpts(requestParameters: EmissioneventsFilesDestroyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling emissioneventsFilesDestroy().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emissioneventsFilesDestroy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fileId'] != null) {
            queryParameters['file_id'] = requestParameters['fileId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/{id}/files/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a file from this EPA Form
     */
    async emissioneventsFilesDestroyRaw(requestParameters: EmissioneventsFilesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.emissioneventsFilesDestroyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a file from this EPA Form
     */
    async emissioneventsFilesDestroy(requestParameters: EmissioneventsFilesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.emissioneventsFilesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for emissioneventsFilesList without sending the request
     */
    async emissioneventsFilesListRequestOpts(requestParameters: EmissioneventsFilesListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emissioneventsFilesList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emissionRecordIds'] != null) {
            queryParameters['emission_record_ids'] = requestParameters['emissionRecordIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/{id}/files/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieves file list for this Event Form.
     */
    async emissioneventsFilesListRaw(requestParameters: EmissioneventsFilesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EventFile>>> {
        const requestOptions = await this.emissioneventsFilesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EventFileFromJSON));
    }

    /**
     * Retrieves file list for this Event Form.
     */
    async emissioneventsFilesList(requestParameters: EmissioneventsFilesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EventFile>> {
        const response = await this.emissioneventsFilesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissioneventsFilesUpdate without sending the request
     */
    async emissioneventsFilesUpdateRequestOpts(requestParameters: EmissioneventsFilesUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emissioneventsFilesUpdate().'
            );
        }

        if (requestParameters['eventFileOperationRequest'] == null) {
            throw new runtime.RequiredError(
                'eventFileOperationRequest',
                'Required parameter "eventFileOperationRequest" was null or undefined when calling emissioneventsFilesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/{id}/files/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EventFileOperationRequestToJSON(requestParameters['eventFileOperationRequest']),
        };
    }

    /**
     * Retrieves file list for this Event Form.
     */
    async emissioneventsFilesUpdateRaw(requestParameters: EmissioneventsFilesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EventFile>> {
        const requestOptions = await this.emissioneventsFilesUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EventFileFromJSON(jsonValue));
    }

    /**
     * Retrieves file list for this Event Form.
     */
    async emissioneventsFilesUpdate(requestParameters: EmissioneventsFilesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EventFile> {
        const response = await this.emissioneventsFilesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissioneventsHistoryList without sending the request
     */
    async emissioneventsHistoryListRequestOpts(requestParameters: EmissioneventsHistoryListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emissioneventsHistoryList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emissionRecordIds'] != null) {
            queryParameters['emission_record_ids'] = requestParameters['emissionRecordIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/{id}/history/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Custom action for returning the history for a given event. The heavy lifting is not happening here!
     */
    async emissioneventsHistoryListRaw(requestParameters: EmissioneventsHistoryListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HistoryEntry>>> {
        const requestOptions = await this.emissioneventsHistoryListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryEntryFromJSON));
    }

    /**
     * Custom action for returning the history for a given event. The heavy lifting is not happening here!
     */
    async emissioneventsHistoryList(requestParameters: EmissioneventsHistoryListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HistoryEntry>> {
        const response = await this.emissioneventsHistoryListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissioneventsList without sending the request
     */
    async emissioneventsListRequestOpts(requestParameters: EmissioneventsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emissionRecordIds'] != null) {
            queryParameters['emission_record_ids'] = requestParameters['emissionRecordIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve Emission Event information.  TODO: rework how state changes are handled (use a PATCH event with custom validation).
     */
    async emissioneventsListRaw(requestParameters: EmissioneventsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEmissionEventFullList>> {
        const requestOptions = await this.emissioneventsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEmissionEventFullListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve Emission Event information.  TODO: rework how state changes are handled (use a PATCH event with custom validation).
     */
    async emissioneventsList(requestParameters: EmissioneventsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEmissionEventFullList> {
        const response = await this.emissioneventsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissioneventsPartialUpdate without sending the request
     */
    async emissioneventsPartialUpdateRequestOpts(requestParameters: EmissioneventsPartialUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emissioneventsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedEmissionEventPartialUpdateRequestToJSON(requestParameters['patchedEmissionEventPartialUpdateRequest']),
        };
    }

    /**
     * A viewset to retrieve Emission Event information.  TODO: rework how state changes are handled (use a PATCH event with custom validation).
     */
    async emissioneventsPartialUpdateRaw(requestParameters: EmissioneventsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmissionEventPartialUpdate>> {
        const requestOptions = await this.emissioneventsPartialUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmissionEventPartialUpdateFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve Emission Event information.  TODO: rework how state changes are handled (use a PATCH event with custom validation).
     */
    async emissioneventsPartialUpdate(requestParameters: EmissioneventsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmissionEventPartialUpdate> {
        const response = await this.emissioneventsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissioneventsRetrieve without sending the request
     */
    async emissioneventsRetrieveRequestOpts(requestParameters: EmissioneventsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emissioneventsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve Emission Event information.  TODO: rework how state changes are handled (use a PATCH event with custom validation).
     */
    async emissioneventsRetrieveRaw(requestParameters: EmissioneventsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmissionEventFull>> {
        const requestOptions = await this.emissioneventsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmissionEventFullFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve Emission Event information.  TODO: rework how state changes are handled (use a PATCH event with custom validation).
     */
    async emissioneventsRetrieve(requestParameters: EmissioneventsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmissionEventFull> {
        const response = await this.emissioneventsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for emissioneventsUpdate without sending the request
     */
    async emissioneventsUpdateRequestOpts(requestParameters: EmissioneventsUpdateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling emissioneventsUpdate().'
            );
        }

        if (requestParameters['emissionEventUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'emissionEventUpdateRequest',
                'Required parameter "emissionEventUpdateRequest" was null or undefined when calling emissioneventsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/emissionevents/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmissionEventUpdateRequestToJSON(requestParameters['emissionEventUpdateRequest']),
        };
    }

    /**
     * A viewset to retrieve Emission Event information.  TODO: rework how state changes are handled (use a PATCH event with custom validation).
     */
    async emissioneventsUpdateRaw(requestParameters: EmissioneventsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmissionEventUpdate>> {
        const requestOptions = await this.emissioneventsUpdateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmissionEventUpdateFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve Emission Event information.  TODO: rework how state changes are handled (use a PATCH event with custom validation).
     */
    async emissioneventsUpdate(requestParameters: EmissioneventsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmissionEventUpdate> {
        const response = await this.emissioneventsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const EmissioneventsBulkArchiveCreateDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissioneventsBulkArchiveCreateDataSourceEnum = typeof EmissioneventsBulkArchiveCreateDataSourceEnum[keyof typeof EmissioneventsBulkArchiveCreateDataSourceEnum];
/**
 * @export
 */
export const EmissioneventsBulkArchiveCreateEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsBulkArchiveCreateEventStatusEnum = typeof EmissioneventsBulkArchiveCreateEventStatusEnum[keyof typeof EmissioneventsBulkArchiveCreateEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsBulkArchiveCreateEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsBulkArchiveCreateEventStatusWithParentStatusEnum = typeof EmissioneventsBulkArchiveCreateEventStatusWithParentStatusEnum[keyof typeof EmissioneventsBulkArchiveCreateEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissioneventsBulkArchiveCreateExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsBulkArchiveCreateExcludeEventStatusEnum = typeof EmissioneventsBulkArchiveCreateExcludeEventStatusEnum[keyof typeof EmissioneventsBulkArchiveCreateExcludeEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsBulkAssignCreateDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissioneventsBulkAssignCreateDataSourceEnum = typeof EmissioneventsBulkAssignCreateDataSourceEnum[keyof typeof EmissioneventsBulkAssignCreateDataSourceEnum];
/**
 * @export
 */
export const EmissioneventsBulkAssignCreateEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsBulkAssignCreateEventStatusEnum = typeof EmissioneventsBulkAssignCreateEventStatusEnum[keyof typeof EmissioneventsBulkAssignCreateEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsBulkAssignCreateEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsBulkAssignCreateEventStatusWithParentStatusEnum = typeof EmissioneventsBulkAssignCreateEventStatusWithParentStatusEnum[keyof typeof EmissioneventsBulkAssignCreateEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissioneventsBulkAssignCreateExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsBulkAssignCreateExcludeEventStatusEnum = typeof EmissioneventsBulkAssignCreateExcludeEventStatusEnum[keyof typeof EmissioneventsBulkAssignCreateExcludeEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsBulkAssignReviewerCreateDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissioneventsBulkAssignReviewerCreateDataSourceEnum = typeof EmissioneventsBulkAssignReviewerCreateDataSourceEnum[keyof typeof EmissioneventsBulkAssignReviewerCreateDataSourceEnum];
/**
 * @export
 */
export const EmissioneventsBulkAssignReviewerCreateEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsBulkAssignReviewerCreateEventStatusEnum = typeof EmissioneventsBulkAssignReviewerCreateEventStatusEnum[keyof typeof EmissioneventsBulkAssignReviewerCreateEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsBulkAssignReviewerCreateEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsBulkAssignReviewerCreateEventStatusWithParentStatusEnum = typeof EmissioneventsBulkAssignReviewerCreateEventStatusWithParentStatusEnum[keyof typeof EmissioneventsBulkAssignReviewerCreateEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissioneventsBulkAssignReviewerCreateExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsBulkAssignReviewerCreateExcludeEventStatusEnum = typeof EmissioneventsBulkAssignReviewerCreateExcludeEventStatusEnum[keyof typeof EmissioneventsBulkAssignReviewerCreateExcludeEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsBulkMoveToInProgressCreateDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissioneventsBulkMoveToInProgressCreateDataSourceEnum = typeof EmissioneventsBulkMoveToInProgressCreateDataSourceEnum[keyof typeof EmissioneventsBulkMoveToInProgressCreateDataSourceEnum];
/**
 * @export
 */
export const EmissioneventsBulkMoveToInProgressCreateEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsBulkMoveToInProgressCreateEventStatusEnum = typeof EmissioneventsBulkMoveToInProgressCreateEventStatusEnum[keyof typeof EmissioneventsBulkMoveToInProgressCreateEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsBulkMoveToInProgressCreateEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsBulkMoveToInProgressCreateEventStatusWithParentStatusEnum = typeof EmissioneventsBulkMoveToInProgressCreateEventStatusWithParentStatusEnum[keyof typeof EmissioneventsBulkMoveToInProgressCreateEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissioneventsBulkMoveToInProgressCreateExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsBulkMoveToInProgressCreateExcludeEventStatusEnum = typeof EmissioneventsBulkMoveToInProgressCreateExcludeEventStatusEnum[keyof typeof EmissioneventsBulkMoveToInProgressCreateExcludeEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsFilesListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissioneventsFilesListDataSourceEnum = typeof EmissioneventsFilesListDataSourceEnum[keyof typeof EmissioneventsFilesListDataSourceEnum];
/**
 * @export
 */
export const EmissioneventsFilesListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsFilesListEventStatusEnum = typeof EmissioneventsFilesListEventStatusEnum[keyof typeof EmissioneventsFilesListEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsFilesListEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsFilesListEventStatusWithParentStatusEnum = typeof EmissioneventsFilesListEventStatusWithParentStatusEnum[keyof typeof EmissioneventsFilesListEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissioneventsFilesListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsFilesListExcludeEventStatusEnum = typeof EmissioneventsFilesListExcludeEventStatusEnum[keyof typeof EmissioneventsFilesListExcludeEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsHistoryListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissioneventsHistoryListDataSourceEnum = typeof EmissioneventsHistoryListDataSourceEnum[keyof typeof EmissioneventsHistoryListDataSourceEnum];
/**
 * @export
 */
export const EmissioneventsHistoryListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsHistoryListEventStatusEnum = typeof EmissioneventsHistoryListEventStatusEnum[keyof typeof EmissioneventsHistoryListEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsHistoryListEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsHistoryListEventStatusWithParentStatusEnum = typeof EmissioneventsHistoryListEventStatusWithParentStatusEnum[keyof typeof EmissioneventsHistoryListEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissioneventsHistoryListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsHistoryListExcludeEventStatusEnum = typeof EmissioneventsHistoryListExcludeEventStatusEnum[keyof typeof EmissioneventsHistoryListExcludeEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type EmissioneventsListDataSourceEnum = typeof EmissioneventsListDataSourceEnum[keyof typeof EmissioneventsListDataSourceEnum];
/**
 * @export
 */
export const EmissioneventsListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsListEventStatusEnum = typeof EmissioneventsListEventStatusEnum[keyof typeof EmissioneventsListEventStatusEnum];
/**
 * @export
 */
export const EmissioneventsListEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsListEventStatusWithParentStatusEnum = typeof EmissioneventsListEventStatusWithParentStatusEnum[keyof typeof EmissioneventsListEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const EmissioneventsListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type EmissioneventsListExcludeEventStatusEnum = typeof EmissioneventsListExcludeEventStatusEnum[keyof typeof EmissioneventsListExcludeEventStatusEnum];
